import { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {
  PanelOverrides,
  StyledHeaderContainer,
  StyledIcon,
  StyledPanelWrapper,
  StyledSubHeaderContainer,
  StyledTitle,
  StyledTitleContainer,
} from './styled-components'
import iconLogo from './unknown--filled.svg'
import { Panel, StatelessAccordion } from 'baseui/accordion'
import { ChevronDown, ChevronUp } from 'baseui/icon'

// eslint-disable-next-line react/prop-types
export const CustomToggleIcon = ({ $expanded, $style, ...restProps }) => {
  const mergedStyle = {
    ...$style,
    width: '1.75rem',
    height: '1.75rem',
  }
  return $expanded ? (
    <ChevronUp color='#808284' {...restProps} style={mergedStyle} />
  ) : (
    <ChevronDown color='#808284' {...restProps} style={mergedStyle} />
  )
}

const RenderLogo = (logo, alt) => {
  if (typeof logo === 'string') {
    return <StyledIcon src={logo} alt={alt} />
  }

  return <div style={{ marginRight: '5px', display: 'flex', alignItems: 'center' }}>{logo}</div>
}

const PanelNew = props => {
  const panelRef = useRef()
  const logo = props.logo ?? iconLogo
  const alt = props.alt ?? 'Alternative text...'
  const title = props.title ?? 'Random child'
  const headerContent = props.headerContent ?? null
  const subHeaderContent = props.subHeaderContent ?? null
  const [expanded, setExpanded] = useState(['initial'])

  if (props.empty === true) {
    return <div ref={panelRef} />
  }

  return (
    <>
      <StyledPanelWrapper ref={panelRef} id={props.id}>
        <StatelessAccordion
          expanded={expanded}
          onChange={({ key, expanded: newExpanded }) => {
            setExpanded(newExpanded)
          }}
          accordion={true}
        >
          <Panel
            key='initial'
            overrides={{
              ...PanelOverrides,
              ToggleIcon: {
                component: CustomToggleIcon,
              },
            }}
            title={
              <StyledTitleContainer>
                <StyledHeaderContainer>
                  {RenderLogo(logo, alt)}
                  <StyledTitle>{title}</StyledTitle>
                  {headerContent && <StyledTitle>{headerContent}</StyledTitle>}
                </StyledHeaderContainer>
                <StyledSubHeaderContainer>{subHeaderContent}</StyledSubHeaderContainer>
              </StyledTitleContainer>
            }
          >
            {props.children}
          </Panel>
        </StatelessAccordion>
      </StyledPanelWrapper>
    </>
  )
}

PanelNew.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.node,
  empty: PropTypes.bool,
  id: PropTypes.string,
  logo: PropTypes.node,
  title: PropTypes.string,
  type: PropTypes.string,
  headerContent: PropTypes.func,
}

export default PanelNew
